export default __webpack_public_path__ + "static/media/8ef1b82dc51035d51e7229af7f78bdd61599843088505.1fbefda2.webp";